export { default } from "./Dialog";
export * from "./Dialog";
